module.exports = __webpack_public_path__ + "media/images/pc/brands/common/main-visual-text-ba4c8ab6b92b5865976ee00b64245f79.svg";